import React, {useContext} from 'react';
import {useTranslation} from "react-i18next";
import ContentBox from "../components/ContentBox";
// @ts-ignore
import { EmbeddedList } from '@performant-software/semantic-components';
import {Icon} from "semantic-ui-react";
import { getActivityIcon, getResourceIcon } from '../utility';
import {FlexRow} from "../layouts";
import { ActivityContext } from '../providers/ActivityProvider';
import moment from 'moment/moment';

export interface IActivity {

}


const Activity = (_props: IActivity) => {
  const {activities} = useContext(ActivityContext);

  const { t } = useTranslation();

  const renderIcon = (key: string, item: any) => {
    return <FlexRow>{item[key] ? <><Icon name={getResourceIcon(item[key])}/><FlexRow padLeft={5}>{t(`resourceTypes.${item[key]}`)}</FlexRow></> : ''}</FlexRow>;
  };

  const renderAction = (key: string, item: any) => {
    return <FlexRow>{item[key] ? <><Icon name={getActivityIcon(item[key])}/><FlexRow padLeft={5}>{t(`activityTypes.${item[key]}`)}</FlexRow></> : ''}</FlexRow>;
  };
  const renderDate = (key: string, item: any) => {
    return <FlexRow>{`${moment(item[key]).format('LLL')}`}</FlexRow>;
  };

  const columns = [
    {
      name: 'dateTime',
      label: t('activity.onDate'),
      sortable: true,
      render: (item: any) => renderDate('dateTime', item),
    },
    {
      name: 'type',
      label: t('activity.fileType'),
      sortable: true,
      render: (item: any) => renderIcon('type', item),
    },
    {
      name: 'name',
      label: t('activity.name'),
      sortable: true,
    },
    {
      name: 'activityType',
      label: t('activity.action'),
      sortable: true,
      render: (item: any) => renderAction('activityType', item),
    },
    {
      name: 'activityMessage',
      label: t('activity.message'),
      sortable: false,
    },
    {
      name: 'userFirstName',
      label: t('activity.user'),
      sortable: true,
    },
  ];
  return (
    <ContentBox widthPct={100} heightPct={75} padding={32}>
      <EmbeddedList
        columns={columns}
        items={activities}
        tableProps={{ width: '100%' }}
        defaultSort='dateTime'
        defaultSortDirection='descending'
      />
    </ContentBox>
  )
}

export default Activity;